var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none"},React.createElement("g",{"transform":"translate(-193.000000, -29.000000)"},React.createElement("g",null,React.createElement("g",{"transform":"translate(180.000000, 19.000000)"},React.createElement("path",{"d":"M20.1485863,15.5242633 L20.48,15.858 L15.14,21.24 L13,19.085 L16.4829001,15.5747064 L13.07,12.135 L15.19,10 L20.41,15.261 L20.1485863,15.5242633 Z"}))))));
}

Arrow.defaultProps = {"width":"8px","height":"12px","viewBox":"0 0 8 12","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
